import { DeviceType } from '../types/DeviceType';
import { win } from './win';

const mobileBreakpoint = 465;

export const getDocumentWidth = (): number =>
  win.innerWidth || document.documentElement.clientWidth;

export const isMobileWidth = (elementWidth: number) =>
  elementWidth <= mobileBreakpoint;

export const getDeviceTypeByWidth = (elementWidth?: number): DeviceType =>
  isMobileWidth(elementWidth) ? 'mobile' : 'desktop';

export const getDeviceTypeByViewportWidth = (): DeviceType =>
  isMobileWidth(win.outerWidth) ? 'mobile' : 'desktop';
